<h5 mat-dialog-title class="pb-0">Feedback for Case / Patient: {{data.refNum}}</h5>
<hr class="p-0 m-0">
<mat-dialog-content class="mat-typography">
    <div class="m-2 p-2">
        <mat-form-field class="w-100">
            <mat-label>Select Feedback</mat-label>
            <mat-select [(ngModel)]="selectedOption">
                <mat-option *ngFor="let option of data.feedbackMap | keyvalue" [value]="option.key">{{option.value}}</mat-option>
            </mat-select>
        </mat-form-field>
        <hr>
        <mat-form-field class="w-100">
            <mat-label>Leave a comment</mat-label>
            <textarea style="height: 200px;" matInput [(ngModel)]="comment"></textarea>
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [disabled]="!selectedOption" (click)="submitFeedback()">OK</button>
    <button mat-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>